import React, { useState } from 'react';
import { X } from 'lucide-react';

export default function Chatbot() {
  const [isOpen, setIsOpen] = useState(false);

  React.useEffect(() => {
    // Add chatbot config
    const config = document.createElement('script');
    const handleClose = `
      window.closeChatbot = function() {
        const iframe = document.querySelector('.chatbase-iframe');
        if (iframe) {
          iframe.style.display = 'none';
        }
      }
    `;

    config.innerHTML = `
      window.embeddedChatbotConfig = {
        chatbotId: "karen-nhzbzsvuz",
        domain: "www.chatbase.co",
        initCallback: function() {
          window.initChatbot = function() {
            const iframe = document.querySelector('.chatbase-iframe');
            if (iframe) {
              iframe.style.display = 'block';
              iframe.style.zIndex = '1000';
              // Add close button
              const closeBtn = document.createElement('button');
              closeBtn.innerHTML = '×';
              closeBtn.style.cssText = 'position:absolute;right:10px;top:10px;background:#6b21a8;color:white;border:none;width:30px;height:30px;border-radius:50%;cursor:pointer;font-size:20px;line-height:1;';
              closeBtn.onclick = window.closeChatbot;
              iframe.parentElement.appendChild(closeBtn);
            }
          }
        }
      }
      ${handleClose}
    `;
    document.head.appendChild(config);

    // Add chatbot script
    const script = document.createElement('script');
    script.src = "https://www.chatbase.co/embed.min.js";
    script.setAttribute('chatbotId', 'karen-nhzbzsvuz');
    script.setAttribute('domain', 'www.chatbase.co');
    script.defer = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(config);
      document.head.removeChild(script);
    };
  }, [isOpen]);

  const toggleChat = () => {
    setIsOpen(!isOpen);
    if (isOpen && window.closeChatbot) {
      window.closeChatbot();
    } else if (!isOpen && window.initChatbot) {
      window.initChatbot();
    }
  };

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={toggleChat}
        className="bg-purple-600 hover:bg-purple-700 text-white p-3 rounded-full shadow-lg transition-colors"
        aria-label={isOpen ? "Close chat" : "Open chat"}
      >
        {isOpen ? (
          <X className="w-6 h-6" />
        ) : (
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )}
      </button>
    </div>
  );
}